import { render, staticRenderFns } from "./ScrollDownComponent.vue?vue&type=template&id=782fabd0&scoped=true&"
import script from "./ScrollDownComponent.vue?vue&type=script&lang=js&"
export * from "./ScrollDownComponent.vue?vue&type=script&lang=js&"
import style0 from "./ScrollDownComponent.vue?vue&type=style&index=0&id=782fabd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782fabd0",
  null
  
)

export default component.exports